import styled from 'styled-components';
import { MTextBlockBasicAlignment } from '../../molecules/MTextBlockBasic/MTextBlockBasic.types';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
  border-radius: var(--t-cards-border-radius);
  transition: transform 0.2s ease-in-out;
  gap: 1rem;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--t-accent-color);
`;

interface TextBlockWrapperProps {
  alignment?: MTextBlockBasicAlignment;
}

export const TextBlockWrapper = styled.div<TextBlockWrapperProps>`
  width: 100%;
  text-align: ${({ alignment }) => (alignment === 'Centered' ? 'center' : 'left')};
`;

export const LinkWrapper = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;

  &:hover ${Wrapper} {
    transform: translateY(-4px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:focus-visible {
    outline: 2px solid var(--t-interactive-accent-color);
    outline-offset: 2px;
    border-radius: var(--t-cards-border-radius);
  }
`;

export const ExternalLinkWrapper = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;

  &:hover ${Wrapper} {
    transform: translateY(-4px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:focus-visible {
    outline: 2px solid var(--t-interactive-accent-color);
    outline-offset: 2px;
    border-radius: var(--t-cards-border-radius);
  }
`;
